/* eslint-disable require-yield */
import { chatsTypes } from "./chats.types";
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeLatest,
} from "redux-saga/effects";
import { uploadAgentAvatar } from "apis/profile";
import io from "socket.io-client";
import { handleRequestErrors } from "../../utils/errorHandler";
import { eventChannel } from "redux-saga";
import { toast } from "react-toastify";
import {
  createContainerObject,
  createSelectedConversationObject,
  createUserMessage,
  getMessageType,
  handleAddPretext,
  handleBlockUser,
  handleChangeAgentOnline,
  handleCloseAllConversations,
  handleEditPretext,
  handleFetchAgentInfo,
  handleFetchAgents,
  handleFetchContainerInfo,
  handleFetchConversation,
  handleFetchConversationUser,
  handleFetchOngoingConversations,
  handleFetchOnlineUsers,
  handleFetchOnlineUsersCount,
  handleFetchPartnerConversation,
  handleFetchPendingConversations,
  handleFetchOptions,
  handleGetAcceptedConversation,
  handleLoginUser,
  handleResetPassword,
  handleRemoveNotSeenConversation,
  handleRemovePretext,
  handleSendMessageForOnlineUser,
  handleSendOperatorMessage,
  handleSetPartnerMessage,
  handleTransferConversation,
  handleUpdateConversation,
  handleUpdateUser,
  uploadFile,
  handleUpdateNotifications,
  handleUpdateAgentProfile,
  handleUpdateTelegramBot,
  handleFetchUserChannels,
  handleLogoutFromSocket,
  handleEditMessage,
  handleFetchUserRoadmap,
  getUserRoadmapObjects,
  handleFetchOtherConversations,
  handleTransferConversationToMe,
  handleFetchTeamsInfo,
  getAdaptedTeams,
  handleFetchBlockedUsersInfo,
  getBlockedUserObj,
  handleUnBlockUser,
  createBotMessage,
  getAdaptedOperators,
  getAcceptingConvObject,
  getClosingConvPayload,
  handleStartConversationWithVisitor,
  createConversationFromNewMsg,
  createSingleConversationObject,
  getConversationsArrayOfObjects,
} from "./chats.adapter";
import {
  addConversationToOngoings,
  removeConversationFromList,
  handleAcceptConversationStart,
  playMessageNotificationSound,
  playNewVisitorSound,
  refreshAgentInfo,
  removeClosedConversation,
  removeConversationNotSeen,
  removeConversationNotSeenBadge,
  setDeliveredMessage,
  setLoadingChats,
  setNewMessage,
  setPartnerNewMessage,
  setPretexts,
  setScrollToBottom,
  setSelectedConversation,
  setTransferedChat,
  setTypingWord,
  setUnreadOngoingMessage,
  setUnreadPendingMessage,
  setUpdatedUser,
  updateOngoingConversations,
  updatePendingConversations,
  setOnlineUsersBadgeStart,
  logoutUser,
  setActingMessage,
  setEditedMessage,
  setSeenStatusForAllMessages,
  setMessageId,
  fetchConversationInfoStart,
  updateUserInfo,
  updateUserAvatarUploadProgress,
  updateConversationAvatar,
  updateChatFileUploadProgress,
  addPendingMessageToTheList,
  removeMessageFromPendingList,
  setHasMoreToLoadConvs,
  setTeams,
  setBlockedUsersList,
  setConversationWithBotStatus,
  updatePendingConversationByNewBotMsg,
  setConversationsList,
  removeTransferredChat,
} from "./chats.actions";
import { createFileObject } from "./chats.helpers";
import { API_URL, POPUP_NAMES } from "../../utils/constants";
import { connectNotification } from "apis/notifications";
import { getTimeBasedOnLocale } from "utils/date";
import { disconnectNotification } from "apis/notifications";
import routes from "routes";
import { getNotifMsg } from "utils/message";
import { isEndedWithMp3Format } from "utils/validation";
import {
  setIsLoggedInUser,
  setLoginLoading,
  setResetPassLoading,
} from "redux/auth/auth.actions";
import {
  setIsConnected,
  setIsReconnecting,
} from "redux/connection/connection.actions";
import {
  loadAgent,
  setAgentInfo,
  setAgents,
  setContainerInfo,
  setConversationCharge,
  setUserChannels,
} from "redux/user/user.actions";
import { setRoadmapData } from "redux/roadmap/roadmap.actions";
import {
  addOnlineUser,
  removeOnlineUser,
  setNotifications,
  setOnlineUsersData,
  setOnlineUsersBadge,
  setFetchOnlineUsersLoadingStatus,
  resetStoreState,
} from "redux/general-data/general-data.actions";
import { getCacheDataActionObj } from "redux/cache/cache.actions";
import { changePopupStatusByLogout } from "utils/persistor";
import * as Sentry from "@sentry/react";
import { getNormalizedUrl } from "utils/url";
import { FCM_TOKEN_KEY } from "constants/localStorageKeys";

function* getToken() {
  let token = localStorage.getItem("raychat_web_app_token");
  return token;
}

const getConversationsInfo = (state) => {
  return {
    pendingConversations: state.chatsData.pending.data,
    ongoingConversations: state.chatsData.ongoing.data,
    selectedConversation: state.chatsData.selectedConversation,
    agent: state.userData.agent.data,
    agents: state.userData.agents.data,
    notifications: state.generalData.notifications,
    userChannels: state.userData.userChannels.data,
    locale: state.settingsData.locale,
    actingMessage: state.chatsData.messageUnderAction,
  };
};

const getBlockedUsersList = ({ chatsData }) => chatsData.blockedUsers;
const getOngoingConvsTotalCount = ({ chatsData }) =>
  chatsData.ongoing.totalCount;
const getIsLoggedInUser = ({ authData }) => authData.isLoggedInUser;
const getPendingConversationsCount = ({ chatsData }) =>
  chatsData.pending.totalCount;

const getTotalCountsOnConvType = ({ chatsData }) => ({
  ongoing: chatsData.ongoing.totalCount,
  pending: chatsData.pending.totalCount,
  otherConvs: chatsData.otherConvs.totalCount,
});

const getConvsLimitsOnConvTypes = ({ chatsData }) => ({
  otherConvs: chatsData.otherConvs.loadLimit,
  pending: chatsData.pending.loadLimit,
  ongoing: chatsData.ongoing.loadLimit,
});
const getConvsListForConvTypes = ({ chatsData }) => ({
  pending: chatsData.pending.data,
  ongoing: chatsData.ongoing.data,
  otherConvs: chatsData.otherConvs.data,
});
const getOtherConvsFeatAccess = ({ userData }) =>
  userData.container.data.otherConversationsEnabled;
const getLocale = ({ settingsData }) => settingsData.locale;
const getOtherOperatorsConvsNum = ({ chatsData }) =>
  chatsData.otherConvs.totalCount;

let socket;

function* connect() {
  let token = yield call(getToken);
  const appSocket = io(API_URL, {
    reconnectionDelayMax: 10000,
    transports: ["websocket"],
    path: "/socket.io",
    query: {
      type: "agent",
      token,
    },
    autoConnect: true,
  });
  socket = appSocket;
  return appSocket;
}

function subscribe(socket, locale) {
  return eventChannel((emit) => {
    socket.on("connect", () => {
      emit(setIsReconnecting(false));
      socket.emit(
        "http",
        {
          method: "post",
          url: "/socket/onlyAddToRoom",
          data: {
            agentId: localStorage.getItem("raychat_web_app_agentId"),
          },
        },
        (resData) => {}
      );
      emit(setIsConnected(true));
    });
    socket.on("error", (event) => {
      console.log("WebSocket error: ", event);
    });
    socket.on("connect_failed", () => {
      toast.error(getNotifMsg("SOCKET_CONNECT_FAILED", locale));
    });
    socket.on("disconnect", (reason) => {
      const isUserLoggedIn = localStorage.getItem(
        "raychat_web_app_is_user_logged_in"
      );

      // do not toast error if socket is disconnected by logout
      if (reason === "io client disconnect" && !isUserLoggedIn) return;

      if (reason === "io server disconnect")
        toast.error(getNotifMsg("IO_SERVER_DISCONNECT", locale));
      else if (reason === "io client disconnect")
        toast.error(getNotifMsg("IO_CLIENT_DISCONNECT", locale));
      else emit(setIsReconnecting(true));
    });
    socket.on("connect_error", (res) => {
      if (res.message === "Invalid token!") {
        toast.error(getNotifMsg("REDIRECT_TO_LOGIN", locale));
        localStorage.removeItem("raychat_web_app_token");
        localStorage.removeItem("raychat_web_app_agentId");
        emit(setIsLoggedInUser(false));
        window.location.href = "/login";
      }
    });

    // this get's called when a conversation is closed by owner operator or the other operator
    socket.on("closeConv", (res) => {
      emit(removeClosedConversation(res.conversationId));
    });

    socket.on("transferChatToYou", (res) => {
      emit(setTransferedChat({ ...res, avatar: getNormalizedUrl(res.avatar) }));
    });

    socket.on("userDetailUpdated", (res) => {
      emit(setUpdatedUser(res.userDetails));
    });

    socket.on("convAccepted", (res) => {
      emit(handleAcceptConversationStart(res));
    });

    socket.on("newMsgClient", async (res) => {
      emit(playMessageNotificationSound(res));

      let conversationStatus;
      /*
        0: chatting an agent with another agent OR chatting agent with an online visitor
        1: closes
        2: pending
        3: ongoing
      */
      switch (res.conversationStatus) {
        case "2":
          conversationStatus = "pending";
          break;
        case "3":
          conversationStatus = "ongoing";
          break;
        case "0":
          conversationStatus = "ongoing";
          break;
        default:
          break;
      }

      let messageType = getMessageType(res);

      if (conversationStatus === "pending") {
        emit(
          updatePendingConversations({
            conversationId: res.conversationId,
            conversation: createConversationFromNewMsg({
              res,
              messageType,
            }),
          })
        );
      }
      if (conversationStatus === "ongoing") {
        const conversation = createConversationFromNewMsg({
          res,
          messageType,
        });

        emit(updateOngoingConversations({ conversation }));
      }

      emit(
        setNewMessage({
          conversationId: res.conversationId,
          message: createUserMessage(res, locale),
        })
      );

      // seet "seen" status for messages that newly recieved.
      if (res.conversationStatus === "3" || res.conversationStatus === "0") {
        emit(
          removeConversationNotSeen({
            conversationId: res.conversationId,
            conversationStatus: conversationStatus,
          })
        );
      }

      if (conversationStatus === "pending") {
        emit(setUnreadPendingMessage(true));
      } else if (conversationStatus === "ongoing") {
        emit(setUnreadOngoingMessage(true));
      }
    });

    socket.on("refreshVisitors", (res) => {
      if (res.leave === false) {
        emit(playNewVisitorSound());
        emit(addOnlineUser(res.user));
      } else {
        emit(removeOnlineUser(res.clientId));
      }
    });

    socket.on("haveMsg", async (res) => {
      emit(setPartnerNewMessage());
      emit(
        setNewMessage({
          conversationId: res.conversationId,
          message: createUserMessage(res, locale),
        })
      );
    });

    socket.on("newConversation", (res) => {
      // emit(setOnlineUsersBadge(res.count));
    });

    socket.on("refreshMyAccount", (res) => {
      emit(refreshAgentInfo());
    });

    socket.on("userTypedMsg", (res) => {
      emit(setTypingWord(res));
    });

    socket.on("conversationSeen", (res) => {
      emit(
        setSeenStatusForAllMessages({
          conversationId: res.conversationId,
          teamId: res.teamId,
        })
      );
    });

    socket.on("conversationBotStatus", (res) => {
      const { conversationId, botStatus } = res;

      emit(setConversationWithBotStatus({ conversationId, status: botStatus }));
    });

    socket.on("refreshAccount", (res) => {
      const { chargeCount } = res;

      emit(setConversationCharge(chargeCount));
    });

    // when message is sent by AI chat bot
    socket.on("chatBot_sendMessage", (res) => {
      const textMessageForUi = createBotMessage(res, locale);

      emit(
        updatePendingConversationByNewBotMsg({
          conversationId: res.conversationId,
          message: res.messageObj?.message,
        })
      );

      emit(
        setNewMessage({
          conversationId: res.conversationId,
          message: textMessageForUi,
        })
      );
    });

    return () => {};
  });
}

// checks if fetched conversation already exists in the conversations list and if it doesn't it will add it to the list
function* checkIfConversationExistsInConvsList({ conversation, convType }) {
  const locale = yield select(getConversationsInfo);
  const totalCountsPerConvType = yield select(getTotalCountsOnConvType);
  const dataLists = yield select(getConvsListForConvTypes);
  const data = dataLists[convType];

  if (!data) return;

  const convExists = data.some((c) => c.id === conversation.id);

  if (!convExists) {
    const updatedList = [
      createSingleConversationObject({ conversation, locale, convType }),
      ...data,
    ];
    const prevTotalCount = totalCountsPerConvType[convType];
    yield put(
      setConversationsList({
        convType,
        data: updatedList,
        totalCount: prevTotalCount + 1,
      })
    );
  }
}

function* fetchConversationInfo({ payload }) {
  let { userId, conversationId, isPartnerChat, setLoading, chatWithVisitor } =
    payload;

  try {
    const { agents, agent, locale } = yield select(getConversationsInfo);
    const blockedUsersList = yield select(getBlockedUsersList);

    const allAgentsArr = [...agents, agent];

    let conversation;
    let selectedConversationObject;
    let userData;

    if (isPartnerChat) {
      conversation = yield call(
        handleFetchPartnerConversation,
        agent.id,
        userId,
        socket
      );

      if (!conversation.success && conversation.data?.field === "agentsId") {
        toast.info("مکالمه موردنظر یافت نشد");
        return;
      }

      // TODO: sync with backend to refactor this flow
      yield put(
        setSelectedConversation({
          user: {
            id: userId,
          },
          conversation:
            conversation.status === -1
              ? {
                  id: "",
                  chats: [],
                }
              : createSelectedConversationObject({
                  conversation,
                  accOwnerId: agent.id,
                  allAgentsArr: [...agents, agent],
                  locale,
                }),
          chatWithPartner: true,
        })
      );

      yield put(setLoadingChats(false));
      return;
    } else {
      conversation = yield call(
        handleFetchConversation,
        conversationId,
        socket
      );

      if (
        (!conversation.success &&
          conversation.data?.field === "conversationId") ||
        conversation.notFound
      ) {
        toast.info("مکالمه موردنظر یافت نشد");
        return;
      }

      userId = conversation.clientId;

      const blockStatus =
        userId && blockedUsersList.find((item) => item.userId === userId);

      const user = yield call(handleFetchConversationUser, userId, socket);

      userData = { ...user[0], blockStatus };
    }

    selectedConversationObject = createSelectedConversationObject({
      conversation,
      allAgentsArr,
      locale,
      accOwnerId: agent.id,
    });

    const { convType } = selectedConversationObject;

    // cache the data
    yield put(
      getCacheDataActionObj({
        conversation: selectedConversationObject,
        user: userData,
        convId: conversationId,
      })
    );

    if (convType === "ongoing") {
      yield put(
        removeConversationNotSeen({
          conversationId,
          conversationStatus: "ongoing",
          isSelectdMessage: true,
        })
      );
    }

    yield checkIfConversationExistsInConvsList({
      conversation: {
        ...conversation,
        user: userData,
      },
      convType,
    });

    yield put(
      setSelectedConversation({
        chatWithPartner: isPartnerChat,
        user: userData,
        conversation: selectedConversationObject,
        chatWithVisitor,
      })
    );

    yield put(setLoadingChats(false));
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  } finally {
    setLoading(false);
  }
}

function* removeConversationNotSeenStart({ payload }) {
  const { selectedConversation } = yield select(getConversationsInfo);
  if (
    (selectedConversation &&
      selectedConversation.conversation.id === payload.conversationId) ||
    payload.isSelectdMessage
  ) {
    const response = yield call(
      handleRemoveNotSeenConversation,
      socket,
      payload.conversationId
    );
    if (response.success) {
      yield put(
        removeConversationNotSeenBadge({
          conversationId: payload.conversationId,
          conversationStatus: payload.conversationStatus,
        })
      );
    }
  }
}

function* sendTextMessage({ payload }) {
  let messageId = Math.random();

  const {
    conversationId,
    clientId,
    message,
    chatWithVisitor,
    chatWithPartner,
  } = payload;

  const { agent, agents, actingMessage, locale } = yield select(
    getConversationsInfo
  );

  let textMessageForUi = {
    content: message,
    type: "text",
    me: true,
    delivered: false,
    id: messageId,
    time: getTimeBasedOnLocale(locale, true),
    author: {
      name: agent.name,
      id: agent?.id,
      avatar: agent.avatar,
    },
    status: "sent",
    createdAt: new Date().toISOString(),
  };

  if (actingMessage?.actionType === "REPLY")
    textMessageForUi["replyId"] = actingMessage?.id || "";

  yield put(
    setNewMessage({
      conversationId: conversationId,
      message: textMessageForUi,
    })
  );
  yield put(setActingMessage(null));

  yield put(
    updateOngoingConversations({
      conversation: {
        id: conversationId,
        lastMessage: message,
        messageTime: getTimeBasedOnLocale(locale, true),
        notSeenMessages: 0,
        // TODO: remove this after backend bug fix
        updatedAtSort: new Date(),
      },
    })
  );

  let messageResponse;

  let textMessageForSocket = {
    conversation: conversationId,
    message: message,
    clientId: clientId,
  };

  if (!!actingMessage?.id)
    textMessageForSocket["replyId"] = actingMessage?.id || "";

  // chat with visitor
  if (chatWithVisitor) {
    messageResponse = yield call(
      handleSendMessageForOnlineUser,
      textMessageForSocket,
      socket
    );
    // update message id
    yield put(
      setMessageId({ prevId: messageId, newId: messageResponse.chat?.id || "" })
    );

    // TODO: WHY? investigate if this approach is correct or not when refactoring
    yield call(fetchConversationsStart, { socket, convType: "pending" });
    yield call(fetchConversationsStart, { socket, convType: "ongoing" });

    // This condition checking is to know whether conversation is started with a user that has visited website for the frist time or not
    const conversationId =
      payload.conversationId && payload.conversationId !== "none"
        ? payload.conversationId
        : messageResponse.conversationId;

    const conversation = yield call(
      handleFetchConversation,
      conversationId,
      socket
    );
    const user = { id: conversation.clientId };
    const conversationObject = createSelectedConversationObject({
      conversation,
      allAgentsArr: [...agents, agent],
      accOwnerId: agent.id,
      locale,
    });

    yield put(
      setSelectedConversation({
        user,
        conversation: conversationObject,
      })
    );
  } else if (chatWithPartner) {
    messageResponse = yield call(
      handleSetPartnerMessage,
      socket,
      message,
      actingMessage?.id,
      clientId
    );
    // update message id
    yield put(
      setMessageId({ prevId: messageId, newId: messageResponse.chat?.id || "" })
    );
    yield call(fetchConversationsStart, { socket, convType: "ongoing" });
  } else {
    textMessageForSocket.tempId = messageId;
    textMessageForSocket.webApp = true;

    messageResponse = yield call(
      handleSendOperatorMessage,
      textMessageForSocket,
      socket
    );
    // update message id
    yield put(
      setMessageId({ prevId: messageId, newId: messageResponse.chatId })
    );
  }

  if (messageResponse || messageResponse.message === "ok") {
    // because response is different in chatWithPartner and other form of conversations
    const chatId = messageResponse.chatId || messageResponse.chat?.id;

    yield put(setDeliveredMessage(chatId));
  }
}

function* watchOnChatFileUploadProgress(channel, messageId, conversationId) {
  const { selectedConversation } = yield select(getConversationsInfo);
  const selectedConversationId = selectedConversation.conversation.id;

  while (true) {
    const data = yield take(channel);
    const progress = data === -1 ? null : data;

    if (selectedConversationId === conversationId) {
      yield put(
        updateChatFileUploadProgress(progress, conversationId, messageId)
      );
    }
  }
}

function* sendFileMessage({ payload }) {
  let { file, fileType, FileData, size } = createFileObject(payload.file);

  const { agent, actingMessage, locale } = yield select(getConversationsInfo);

  const messageType = getMessageType({ type: fileType });
  let fileMessageId = Math.random();

  let operatorFileMessageForUi = {
    content: "",
    type: messageType,
    me: true,
    delivered: false,
    size,
    id: fileMessageId,
    url: window.URL.createObjectURL(file),
    name: payload.file.name,
    createdAt: new Date().toISOString(),
    time: getTimeBasedOnLocale(locale, true),
    author: {
      name: agent.name,
      id: agent.id,
      avatar: agent.avatar,
    },
    status: "sent",
  };

  // check if filetype should track for it's progress or not
  const shouldTrackProgress = ["file", "compress", "audio", "video"].includes(
    messageType
  );

  if (actingMessage?.actionType === "REPLY")
    operatorFileMessageForUi["replyId"] = actingMessage.id;

  yield put(
    setNewMessage({
      conversationId: payload.conversationId,
      message: operatorFileMessageForUi,
    })
  );

  if (shouldTrackProgress) {
    yield put(
      addPendingMessageToTheList(
        operatorFileMessageForUi,
        payload.conversationId
      )
    );
  }

  yield put(
    updateOngoingConversations({
      conversation: {
        id: payload.conversationId,
        lastMessage: getMessageType({ type: fileType }),
        messageTime: getTimeBasedOnLocale(locale, true),
        notSeenMessages: 0,
        // TODO: reomve this after backend bug fix
        updatedAtSort: new Date(),
      },
    })
  );

  const [uploadPromise, channel] = yield call(
    uploadFile,
    file,
    fileType,
    FileData,
    payload.conversationId,
    payload.clientId,
    socket,
    actingMessage?.id
  );

  if (shouldTrackProgress) {
    yield fork(
      watchOnChatFileUploadProgress,
      channel,
      fileMessageId,
      payload.conversationId
    );
  }

  const response = yield call(uploadPromise);

  // because response is different in chatWithPartner and other form of conversations
  const newId = response.chatId || response.chat?.id;

  yield put(setMessageId({ prevId: fileMessageId, newId }));

  if (shouldTrackProgress) {
    yield put(
      removeMessageFromPendingList(payload.conversationId, fileMessageId)
    );
  }

  if (
    response.success ||
    (!response.success && response.message === "Invalid token")
  ) {
    yield put(setDeliveredMessage(newId));
  }
}

function* editMessage({ payload }) {
  const { conversationId, message, messageId } = payload;

  // send edit req
  const res = yield call(
    handleEditMessage,
    { conversationId, message, messageId },
    socket
  );

  if (res.status === 200) {
    // edit message in ui
    yield put(setEditedMessage(message, messageId));

    // update edited message in `last message` section of related conversation in conversations list
    yield put(
      updateOngoingConversations({
        conversation: { id: conversationId, lastMessage: message },
        updateNotSeen: false,
      })
    );
  }
}

function* acceptConversation({ payload }) {
  try {
    const { convId, userId, navigate } = payload;
    if (!convId && userId) {
      const res = yield call(handleStartConversationWithVisitor, {
        socket,
        userId,
      });

      if (res.data.message === "message assigned to you") {
        const conversationId = res.data.data.conversation.id;

        navigate && navigate(`${routes.chats}/${conversationId}`);
      }

      return;
    }

    const { agent } = yield select(getConversationsInfo);
    const acceptConvPayload = getAcceptingConvObject({ agent, convId, userId });
    let res = yield call(handleUpdateConversation, acceptConvPayload, socket);

    if (res.success) {
      yield put(addConversationToOngoings(convId));
      yield put(
        fetchConversationInfoStart({
          userId,
          conversationId: convId,
          isPartnerChat: false,
        })
      );
    }
  } catch (error) {
    console.log("Error while accepting conversation: ", error);
    Sentry.captureMessage(error, "error");
  }
}

function* closeConversation({ payload }) {
  try {
    const { locale } = yield select(getConversationsInfo);
    const { convId, userId, action, onSuccess } = payload;

    const closeConvPayload = getClosingConvPayload({ action, convId, userId });

    let response = yield call(
      handleUpdateConversation,
      closeConvPayload,
      socket
    );

    if (response.success) {
      const notifText =
        payload.action === "close" ? "CONV_CLOSED" : "CONV_REJECTED";
      toast.success(getNotifMsg(notifText, locale));
      onSuccess && onSuccess();
    }
  } catch (error) {
    console.log("Error while closing conversation: ", error);
    Sentry.captureMessage(error, "error");
  }
}

function* transferConversation({ payload }) {
  yield call(handleTransferConversation, payload, socket);
}

function* acceptTransferedConversation({ payload, navigate }) {
  const res = yield call(handleUpdateConversation, payload, socket);

  if (res.success) {
    const { id: conversationId, clientId } = res;

    yield call(takeTransferredChatAction, {
      conversationId,
      clientId,
      navigate,
    });

    yield put(removeTransferredChat(conversationId));
  }
}

function* rejectTransferedConversation({ payload }) {
  const res = yield call(handleUpdateConversation, payload, socket);

  if (res.success) {
    yield put(removeTransferredChat(payload.id));
  }
}

// This function needs refactor in my opinion
function* handleAcceptConversation({ payload }) {
  const {
    pendingConversations,
    ongoingConversations,
    agent,
    selectedConversation,
    locale,
  } = yield select(getConversationsInfo);

  const pendingConvsTotalCount = yield select(getPendingConversationsCount);
  const ongoingConvsTotalCount = yield select(getOngoingConvsTotalCount);
  const convsListForTypes = yield select(getConvsListForConvTypes);
  const accessToOtherConvs = yield select(getOtherConvsFeatAccess);
  const otherOperatorsConvs = convsListForTypes.otherConvs;
  const otherOperatorsConvsNum = yield select(getOtherOperatorsConvsNum);

  const conversationId = payload.conversationId;
  const pendingConversation = pendingConversations.find(
    (conv) => conv.id === conversationId
  );
  const ongoingConversation = ongoingConversations.find(
    (conv) => conv.id === conversationId
  );

  // when a pending conversation is accepted by another operator it removes it from conversations list and also sets selected conversation to null if it is the current selected conversation
  if (pendingConversation) {
    let adaptedPendings = pendingConversations;
    if (!pendingConversation.isTransferedMessage) {
      if (agent.id !== payload.userId) {
        adaptedPendings = adaptedPendings.filter(
          (conv) => conv.id !== conversationId
        );
        if (
          selectedConversation &&
          selectedConversation.conversation.id === conversationId
        ) {
          yield put(setSelectedConversation(null));
        }
      }
    } else {
      // TODO: this block seems redundant. consider when refactoring
      adaptedPendings = adaptedPendings.forEach((conv) => {
        if (conv.id === conversationId) {
          delete conv.isTransferedMessage;
          return conv;
        } else {
          return conv;
        }
      });
    }

    yield put(
      setConversationsList({
        convType: "pending",
        data: adaptedPendings,
        totalCount: pendingConvsTotalCount - 1,
      })
    );
  }

  // when ongoing conversation is accepted by another operator. it mainly happens when a conversation is already transfered and the transfer operation is accepteed by receiver operator
  if (ongoingConversation) {
    let adaptedOngoings = ongoingConversations;

    if (!ongoingConversation.isTransferedMessage) {
      if (agent.id !== payload.userId) {
        adaptedOngoings = adaptedOngoings.filter(
          (conv) => conv.id !== conversationId
        );
        if (
          selectedConversation &&
          selectedConversation.conversation.id === conversationId
        ) {
          yield put(setSelectedConversation(null));
        }
      }
    } else {
      adaptedOngoings.forEach((conv) => {
        if (conv.id === conversationId) {
          delete conv.isTransferedMessage;
        }
      });
    }

    yield put(
      setConversationsList({
        convType: "ongoing",
        totalCount: ongoingConvsTotalCount,
        data: adaptedOngoings,
      })
    );
  }

  // check if conversation is accepted by the current agent (account owner) or not and if other convs is available in the package.
  // conversation should not get added to other convs list if it is accepted by the account owner
  if (accessToOtherConvs && agent.id !== payload.userId) {
    const adaptedConvForOtherConvs = ongoingConversation
      ? ongoingConversation
      : payload.conv
      ? createSingleConversationObject({
          conversation: payload.conv,
          locale,
        })
      : undefined;

    const updatedConvsList = [adaptedConvForOtherConvs, ...otherOperatorsConvs];

    if (adaptedConvForOtherConvs) {
      yield put(
        setConversationsList({
          convType: "otherConvs",
          data: updatedConvsList,
          totalCount: otherOperatorsConvsNum + 1,
        })
      );
    }
  }
}

function* addNewPretext({ payload }) {
  const { agent, locale } = yield select(getConversationsInfo);
  const formData = payload;
  const response = yield call(handleAddPretext, socket, formData);
  if (response.success) {
    yield call(fetchPretextsStart, socket, agent.id);
    toast.success(getNotifMsg("NEW_PRETEXT_ADDED", locale));
  }
}

function* fetchChannelSettingsStart({ payload }) {
  const response = yield call(handleFetchOptions, socket, "channelSetting");
  if (response.success) {
    // console.log("channelSettings", response);
  }
}

function* fetchUserSettingsStart(agent_id) {
  const response = yield call(handleFetchOptions, socket, `user_${agent_id}`);
  let notifications;
  if (response && response.meta) {
    notifications = {
      NewMsgInConversationSound: response.meta.NewMsgInConversationSound,
      NewMsgSound: response.meta.NewMsgSound,
      NewVisitorSound: response.meta.NewVisitorSound,
      enabled: response.meta.enabled,
    };
  } else {
    notifications = {
      NewMsgInConversationSound: "disable",
      NewMsgSound: "disable",
      NewVisitorSound: "disable",
      enabled: false,
    };
  }
  yield put(setNotifications(notifications));
}

function* removePretext({ payload }) {
  const { agent, locale } = yield select(getConversationsInfo);
  const formData = payload;
  const response = yield call(handleRemovePretext, socket, formData);
  if (response.success) {
    yield call(fetchPretextsStart, socket, agent.id);
    toast.success(getNotifMsg("PRETEXT_REMOVED", locale));
  }
}

function* editPretext({ payload }) {
  const { agent, locale } = yield select(getConversationsInfo);
  const formData = payload;
  const response = yield call(handleEditPretext, socket, formData);
  if (response.success) {
    yield call(fetchPretextsStart, socket, agent.id);
    toast.success(getNotifMsg("PRETEXT_EDITED", locale));
  }
}

/**
 * data used for updating ui
 * @typedef {object} data
 * @property {string} userId
 * @property {string} ip
 * @property {string} action - it can be 'remove' (for unblock) and add (for block) action
 * @property {Object | null | undefined} newBlockStatus
 *
 * This function updates UI after block/unblock of a user
 *
 */
function* updateUiWhenBlockStatusChanges(data) {
  const { userId, action, newBlockStatus } = data || {};
  const { selectedConversation } = yield select(getConversationsInfo);
  const blockedUsersList = yield select(getBlockedUsersList);
  let newBlockedUsersList;

  const updatedUser = {
    ...selectedConversation.user,
    blockStatus: newBlockStatus,
  };

  // updating conversations list according to the action
  if (action === "add") {
    newBlockedUsersList = [...blockedUsersList, newBlockStatus];
  } else if (action === "remove") {
    newBlockedUsersList = blockedUsersList.filter(
      (item) => item.userId !== userId
    );
  }

  yield put(
    setSelectedConversation({ ...selectedConversation, user: updatedUser })
  );
  // updating conversations list
  yield put(setBlockedUsersList(newBlockedUsersList));
}

function* blockUser({ payload }) {
  const { locale } = yield select(getConversationsInfo);

  try {
    const res = yield call(handleBlockUser, socket, payload);
    const blockPeriod = payload.end;
    const userId = payload.id;
    const ip = payload.ip;

    if (!res.err) {
      const blockedUserObj = getBlockedUserObj({ userId, ip, blockPeriod });

      const updateUiData = {
        action: "add",
        newBlockStatus: blockedUserObj,
        userId,
        ip,
      };

      // updating UI according to new block status
      yield call(updateUiWhenBlockStatusChanges, updateUiData);
      toast.success(getNotifMsg("BLOCK_USER_SUCCESS", locale));
    }

    // user has already been blocked
    if (res.err === "duplicate") {
      toast.success(getNotifMsg("BLOCK_USER_ERROR_DUPLICATE", locale));
    }
  } catch (error) {
    console.log(error);
  }
}

function* unBlockUser({ payload }) {
  try {
    const { userId } = payload;
    const { locale } = yield select(getConversationsInfo);
    const payloadData = { userId };
    const res = yield call(handleUnBlockUser, socket, payloadData);

    if (res.message === "success") {
      const updateUiData = {
        action: "remove",
        newBlockStatus: null,
        userId: payload.userId,
        ip: payload.ip,
      };

      yield call(updateUiWhenBlockStatusChanges, updateUiData);
      toast.success(getNotifMsg("USER_UNBLOCKED_SUCCESS", locale));
    }
  } catch (error) {
    console.log(error);
  }
}

function* watchOnProgress(chan, id, type) {
  const { selectedConversation } = yield select(getConversationsInfo);
  while (true) {
    const data = yield take(chan);
    const progress = data === -1 ? null : data;

    if (id && type) {
      yield put(updateConversationAvatar(type, id, progress));
    } else {
      yield put(
        updateUserAvatarUploadProgress(selectedConversation?.user?.id, progress)
      );
    }
  }
}

function* updateUserAvatar({ payload }) {
  const { fileObj, conversationId, conversationType, userId } = payload;
  let { file, fileType, FileData } = createFileObject(fileObj.file);
  const { selectedConversation, locale } = yield select(getConversationsInfo);
  const [uploadPromise, channel] = yield call(
    uploadFile,
    file,
    fileType,
    FileData,
    undefined,
    undefined,
    socket,
    undefined,
    true,
    locale
  );

  yield fork(watchOnProgress, channel, conversationId, conversationType);

  const response = yield call(uploadPromise);

  if (conversationId && conversationType) {
    yield put(updateConversationAvatar(conversationType, conversationId, null));
  } else {
    yield put(
      updateUserAvatarUploadProgress(selectedConversation.user.id, null)
    );
  }

  if (
    // upload avatar from UserInfoBox
    (!conversationId && !conversationType && !userId) ||
    // upload avatar from conversations list
    (conversationId &&
      conversationType &&
      userId &&
      selectedConversation &&
      selectedConversation?.user?.id === userId)
  ) {
    const userData = {
      ...selectedConversation?.user,
      avatar: response.id,
    };

    yield put(updateUserInfo({ data: userData }));
  }

  if (
    // upload avatar from UserInfoBox
    (!conversationId && !conversationType && !userId) ||
    // upload avatar from conversations list
    (conversationId &&
      conversationType &&
      userId &&
      selectedConversation &&
      selectedConversation?.user?.id === userId)
  ) {
    yield put(
      setSelectedConversation({
        ...selectedConversation,
        user: {
          ...selectedConversation.user,
          avatar: response.id,
        },
      })
    );
  }
}

function* updateUser({ payload }) {
  const { locale } = yield select(getConversationsInfo);
  const { data: userInfo, convType } = payload;

  // filtering undefined values
  const filteredEntries = Object.entries(userInfo).filter(
    ([, value]) => !!value
  );
  const filteredObj = Object.fromEntries(filteredEntries);

  if (!userInfo.about) {
    delete userInfo.about;
  }

  const response = yield call(handleUpdateUser, socket, filteredObj);
  if (response.success) {
    toast.success(getNotifMsg("USER_INFO_SAVED", locale));
    yield fork(fetchConversationsStart, { socket, convType });
  }
}

function* closeAllConversations({ payload }) {
  let agentId = payload;
  const response = yield call(handleCloseAllConversations, socket, agentId);
  if (response.success && !agentId) {
    yield put(
      setConversationsList({
        convType: "pending",
        data: [],
        totalCount: 0,
      })
    );
  }
}

function* changeAgentOnline({ payload }) {
  const isOnline = payload;
  const response = yield call(handleChangeAgentOnline, socket, isOnline);
  if (response.success) {
    yield put(
      setAgentInfo({
        online: payload,
      })
    );
  }
}

function* handleStartChatWithOnlineUser({ payload }) {
  try {
    const { userId, navigate } = payload;

    const conversation = yield call(
      handleFetchConversation,
      userId,
      socket,
      0,
      true
    );

    // no conversation ID happens when user have never had a conversation before
    const convId = conversation.id || "newUser";
    const userIdParam = !conversation.id ? `?userId=${userId}` : "";

    navigate(`${routes.chats}/${convId}${userIdParam}`);

    if (conversation.notFound && convId !== "newUser") {
      toast.info("مکالمه مورد نظر یافت نشد");
    }
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

function* handleStartChatWithPartner({ payload }) {
  try {
    const { agent } = yield select(getConversationsInfo);
    let { partnerId, navigate } = payload;

    let conversation = yield call(
      handleFetchPartnerConversation,
      agent.id,
      partnerId,
      socket
    );

    const convId = conversation.id || "newOperatorConv";

    navigate(
      `${routes.chats}/${convId}?userId=${partnerId}&isPartnerChat=true`
    );
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

function* setPartnerMessage() {
  yield call(fetchConversationsStart, { socket, convType: "ongoing" });
}

function* playSoundForNewMsg({ payload }) {
  try {
    const message = payload;
    const { notifications, selectedConversation } = yield select(
      getConversationsInfo
    );

    // do not play sound if notifications are disabled
    if (!notifications.enabled) return;

    if (
      selectedConversation &&
      message.conversationId === selectedConversation.conversation.id
    ) {
      let audio = new Audio(notifications.NewMsgInConversationSound);
      audio.play();
    } else {
      let audio = new Audio(notifications.NewMsgSound);
      audio.play();
    }
  } catch (error) {
    console.error("An error occurred while playing sound:", error);
    Sentry.captureMessage(error, "error");
  }
}

function* playSoundForNewVisitor() {
  try {
    const { notifications } = yield select(getConversationsInfo);

    // NOTE: it is not best method for covering sound validation. maybe listing valid addresses and seeking validation from them is more better.
    const doesAddressEndsWithMp3 = isEndedWithMp3Format(
      notifications.NewVisitorSound
    );

    // do not play if notification is disabled
    if (!doesAddressEndsWithMp3) return;

    var audio = new Audio(notifications.NewVisitorSound);
    audio.play();
  } catch (error) {
    console.error("An error occurred while playing sound:", error);
    Sentry.captureMessage(error, "error");
  }
}

function* updateNotifications({ payload }) {
  const notificationSettings = payload;
  const { locale } = yield select(getConversationsInfo);

  const response = yield call(
    handleUpdateNotifications,
    socket,
    notificationSettings
  );

  if (response.updated) {
    yield put(setNotifications(notificationSettings));
    toast.success(getNotifMsg("ALARMS_SAVED_SUCCESS", locale));
  }
}

function* updateOnlineUsersCount() {
  const { userChannels } = yield select(getConversationsInfo);
  const userChannelsId = !!userChannels?.length
    ? userChannels?.map((item) => item.id)
    : [];

  const resData = yield call(
    handleFetchOnlineUsersCount,
    socket,
    userChannelsId
  );

  if (resData.success) {
    yield put(setOnlineUsersBadge(resData.onlineUsersCount));
  }
}

function* uploadAvatarPhoto(file, agentId, showToast = true) {
  const { locale } = yield select(getConversationsInfo);
  try {
    const response = yield call(uploadAgentAvatar, agentId, file);
    if (response.success) {
      // showToast && toast.success("بارگذاری تصویر با موفقیت انجام شد");
      showToast &&
        toast.success(getNotifMsg("AVATAR_UPLOADED_SUCCESSFULLY", locale));
      return response.filePath;
    }
    // toast.error("بارگذاری تصویر با مشکل مواجه شد");
    toast.error(getNotifMsg("AVATAR_UPLOAD_FAILED", locale));
    return false;
  } catch (error) {
    if (error.response?.data?.message === "file not support") {
      toast.error(getNotifMsg("INVALID_FILE_FORMAT", locale));
      return;
    }
    // no connection
    if (error.message === "Network Error") {
      // toast.error(
      //   "عدم ارتباط با سرور ! لطفا اتصال خود را به اینترنت بررسی کنید ."
      // );
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }

    handleRequestErrors(error.response, locale);
  }
}

function* updateAgent({ payload }) {
  const { agentInfo, newAvatar, setLoadingSubmit } = payload;
  const { locale } = yield select(getConversationsInfo);

  try {
    // check if photo is changed and should be uploaded
    if (newAvatar && newAvatar.file) {
      const uploadedPhotoUrl = yield call(
        uploadAvatarPhoto,
        newAvatar.file,
        agentInfo.id,
        false
      );

      // change avatar to the newly uploaded url if upload is successful
      if (uploadedPhotoUrl) {
        agentInfo.avatar = uploadedPhotoUrl;
      }
    }

    const response = yield call(handleUpdateAgentProfile, socket, agentInfo);
    if (response.success) {
      toast.success(getNotifMsg("SETTINGS_SAVED_SUCCESS", locale));
      yield call(fetchAgentInfoStart, socket, agentInfo.id);
    }
  } catch (error) {
    // no connection
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }
    Sentry.captureMessage(error, "error");
    handleRequestErrors(error.response, locale);
  } finally {
    setLoadingSubmit(false);
  }
}

function* updateTelegram({ payload }) {
  const isTelegramActive = payload;
  const { agent, locale } = yield select(getConversationsInfo);
  const response = yield call(
    handleUpdateTelegramBot,
    socket,
    isTelegramActive
  );
  if (response.success) {
    if (isTelegramActive)
      toast.success(getNotifMsg("TELEGRAM_BOT_ACTIVATED", locale));
    else toast.success(getNotifMsg("TELEGRAM_BOT_DISABLED", locale));

    yield call(fetchAgentInfoStart, socket, agent.id);
  }
}

function* refreshAgent() {
  const { agent } = yield select(getConversationsInfo);

  yield call(fetchAgentInfoStart, socket, agent.id);
}

function* fetchChatMessages({ payload }) {
  const { conversationId, skip } = payload;
  const { selectedConversation, agent, agents, locale } = yield select(
    getConversationsInfo
  );
  const conversation = yield call(
    handleFetchConversation,
    conversationId,
    socket,
    skip
  );
  const { chats, status } = createSelectedConversationObject({
    conversation,
    allAgentsArr: [...agents, agent],
    accOwnerId: agent.id,
    locale,
  });

  if (selectedConversation) {
    let adaptedConversation = {
      ...selectedConversation,
      conversation: {
        ...selectedConversation.conversation,
        chats: [...chats, ...selectedConversation.conversation.chats],
        status,
      },
    };
    yield put(setSelectedConversation(adaptedConversation));
    yield put(setScrollToBottom(false));
  }
}

// socket loggout + app loggout
function* logoutFromSocket({ payload }) {
  const { navigate } = payload;

  const response = yield call(handleLogoutFromSocket, socket);
  if (response.success) {
    yield put(resetStoreState());

    const fcmToken = localStorage.getItem(FCM_TOKEN_KEY);
    const userToken = localStorage.getItem("raychat_web_app_token");

    changePopupStatusByLogout(POPUP_NAMES.NEW_FEATURES, true);
    changePopupStatusByLogout(POPUP_NAMES.NOTIF_POPUP);
    localStorage.removeItem("raychat_web_app_agentId");
    localStorage.removeItem("raychat_web_app_token");
    localStorage.removeItem("DO_NOT_SHOW_NOTIF_ALERT_AGAIN");
    localStorage.removeItem(FCM_TOKEN_KEY);

    navigate("/login");

    yield put(setIsConnected(false));
    yield put(setIsLoggedInUser(false));
    yield put(logoutUser());
    yield socket.disconnect();

    if (fcmToken) {
      const response = yield call(disconnectNotification, fcmToken, userToken);
      console.log(response);
    }
  }
}

function* fetchUserRoadmapStart({ payload }) {
  const { locale } = yield select(getConversationsInfo);

  try {
    const { userId, setShowModal, showNotif } = payload;
    const response = yield call(handleFetchUserRoadmap, userId, socket);

    if (!response.success && response.status === 404) {
      if (!!showNotif) {
        toast.info(getNotifMsg("NO_ROADMAP_RECORDED", locale));
      }
      return;
    }

    const roadmapData = getUserRoadmapObjects(response);
    yield put(setRoadmapData(roadmapData));
    if (!!setShowModal) {
      setShowModal(true);
    }
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

//actions for creating transferred chat. pay attention that this method is being called both for
// transferring from one agent to another and when one agent transferrs another agent's conversation to himself/herself
function* takeTransferredChatAction({ conversationId, clientId, navigate }) {
  try {
    let conversationInfo = {
      conversationId,
      acceptedBy: clientId,
      isTransfered: true,
    };
    const res = yield call(
      handleGetAcceptedConversation,
      conversationInfo,
      socket
    );

    if (res.success) {
      // 'transferred' query gets added to start fetching conversation even if user has already selected the conversation
      navigate(`${routes.chats}/${conversationId}?transferred=true`);

      yield put(
        removeConversationFromList({ conversationId, listType: "otherConvs" })
      );
    }
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

function* setNewOnlineUserConv({ payload }) {
  try {
    const userId = payload;
    const { agents, agent, locale } = yield select(getConversationsInfo);

    const conversation = createSelectedConversationObject({
      conversation: {
        convType: "closed",
      },
      allAgentsArr: [...agents, agent],
      accOwnerId: agent.id,
      locale,
    });

    const user = yield call(handleFetchConversationUser, userId, socket);

    yield put(
      setSelectedConversation({
        user: user[0],
        conversation,
      })
    );
  } catch (error) {
    console.log(error);
  }
}

// when one agent takes another agent's conversation
function* transferConversationToMe({ payload }) {
  const { conversationId, clientId, navigate } = payload;
  const locale = yield select(getLocale);

  try {
    const res = yield call(
      handleTransferConversationToMe,
      conversationId,
      socket
    );

    if (res.success) {
      yield call(takeTransferredChatAction, {
        conversationId,
        clientId,
        navigate,
      });
    } else {
      toast.error(getNotifMsg("OPERATION_FAILED", locale));
    }
  } catch (error) {
    //TODO: complete error handling
    // no connection
    if (error?.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }

    Sentry.captureMessage(error, "error");
  }
}

function* onFetchUserRoadmapStart() {
  yield takeLatest(chatsTypes.FETCH_USER_ROADMAP, fetchUserRoadmapStart);
}

function* write() {
  yield takeLatest(chatsTypes.FETCH_CONVERATION_INFO, fetchConversationInfo);
  yield takeLatest(chatsTypes.SET_NEW_ONLINE_USER_CONV, setNewOnlineUserConv);

  yield takeLatest(
    chatsTypes.REMOVE_CONVERSATION_NOT_SEEN,
    removeConversationNotSeenStart
  );
  yield takeLatest(chatsTypes.SEND_TEXT_MESSAGE, sendTextMessage);
  yield takeLatest(chatsTypes.SEND_FILE_MESSAGE, sendFileMessage);
  yield takeLatest(chatsTypes.ACCEPT_CONVERSATION_START, acceptConversation);
  yield takeLatest(chatsTypes.CLOSE_CONVERSATION_START, closeConversation);
  yield takeLatest(
    chatsTypes.TRANSFER_CONVERSATION_START,
    transferConversation
  );
  yield takeLatest(
    chatsTypes.TRANSFER_CONVERSATION_TO_ME,
    transferConversationToMe
  );
  yield takeLatest(
    chatsTypes.ACCEPT_TRANSFERED_CONVERSATION_START,
    acceptTransferedConversation
  );
  yield takeLatest(
    chatsTypes.REJECT_TRANSFERED_CONVERSATION_START,
    rejectTransferedConversation
  );
  yield takeLatest(
    chatsTypes.HANDLE_ACCEPTED_CONVERSATION,
    handleAcceptConversation
  );
  yield takeLatest(chatsTypes.ADD_PRETEXT_START, addNewPretext);
  yield takeLatest(chatsTypes.REMOVE_PRETEXT_START, removePretext);
  yield takeLatest(chatsTypes.EDIT_PRETEXT_START, editPretext);
  yield takeLatest(chatsTypes.BLOCK_USER_START, blockUser);
  yield takeLatest(chatsTypes.UNBLOCK_USER, unBlockUser);
  yield takeLatest(chatsTypes.FETCH_AGENTS_START, fetchAgentsStart);
  yield takeLatest(chatsTypes.UPDATE_USER_INFO, updateUser);
  yield takeLatest(chatsTypes.UPDATE_USER_AVATAR, updateUserAvatar);
  yield takeLatest(chatsTypes.CLOSE_ALL_CONVERSATIONS, closeAllConversations);
  yield takeLatest(chatsTypes.SET_AGENT_ONLINE, changeAgentOnline);
  yield takeLatest(
    chatsTypes.CHAT_WITH_ONLINE_USER_START,
    handleStartChatWithOnlineUser
  );
  yield takeLatest(
    chatsTypes.CHAT_WITH_PARTNER_START,
    handleStartChatWithPartner
  );
  yield takeLatest(chatsTypes.SET_PARTNER_NEW_MESSAGE, setPartnerMessage);
  yield takeLatest(
    chatsTypes.PLAY_MESSAGE_NOTIFICATION_SOUND,
    playSoundForNewMsg
  );
  yield takeLatest(chatsTypes.PLAY_NEW_VISITOR_SOUND, playSoundForNewVisitor);
  yield takeLatest(chatsTypes.UPDATE_NOTIFICATION_SOUNDS, updateNotifications);
  yield takeLatest(chatsTypes.UPDATE_AGENT_PROFILE, updateAgent);
  yield takeLatest(chatsTypes.UPDATE_TELEGRAM_BOT, updateTelegram);
  yield takeLatest(chatsTypes.REFRESH_AGENT_INFO, refreshAgent);
  yield takeLatest(chatsTypes.FETCH_MORE_MESSAGES, fetchChatMessages);
  yield takeLatest(chatsTypes.LOGOUT_SOCKT, logoutFromSocket);
  yield takeLatest(
    chatsTypes.SET_ONLINE_USERS_BADGE_START,
    updateOnlineUsersCount
  );
  yield takeLatest(chatsTypes.FETCH_ONLINE_USERS_START, fetchOnlineUsersStart);
  yield takeLatest(chatsTypes.EDIT_MESSAGE_START, editMessage);
}

function* read(socket) {
  const { locale } = yield select(getConversationsInfo);
  const isUserLoggedIn = yield select(getIsLoggedInUser);

  const channel = yield call(subscribe, socket, locale, isUserLoggedIn);
  while (true) {
    let action = yield take(channel);
    yield put(action);
  }
}

function* handleIO(socket) {
  yield fork(read, socket);
  yield fork(write, socket);
}

function* fetchConversationsStart({
  socket,
  convType,
  sort,
  skip = 0,
  replace = true,
}) {
  try {
    const { locale } = yield select(getConversationsInfo);
    const loadLimitsPerConvType = yield select(getConvsLimitsOnConvTypes);
    const convsListForConvTypes = yield select(getConvsListForConvTypes);
    const loadLimit = loadLimitsPerConvType[convType];

    const fetchFuncsPerConvType = {
      pending: handleFetchPendingConversations,
      ongoing: handleFetchOngoingConversations,
      otherConvs: handleFetchOtherConversations,
    };

    const fetchFunc = fetchFuncsPerConvType[convType];
    const convsList = convsListForConvTypes[convType];

    let conversationsObj = yield call(fetchFunc, {
      socket,
      skip,
      limit: loadLimit,
      sort,
    });

    const conversations = conversationsObj.conversations;
    const totalCount = conversationsObj.conversationCount;

    const prevList = replace ? [] : convsList;

    const [filteredConvs, newTotalCount] = getConversationsArrayOfObjects({
      conversations,
      locale,
      convType,
      totalCount,
    });

    const adaptedConversations = [...prevList, ...filteredConvs];

    yield put(
      setConversationsList({
        convType,
        data: adaptedConversations,
        totalCount: newTotalCount,
      })
    );

    const hasMoreToLoad = !(conversations && totalCount < loadLimit);

    yield put(setHasMoreToLoadConvs({ convType, hasMore: hasMoreToLoad }));
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

export function* sortOngoingConvsStart({ payload }) {
  try {
    // from newest to oldes is -1 and on the contray is 1
    const sort = payload === "descending" ? -1 : 1;

    yield call(fetchConversationsStart, { socket, convType: "ongoing", sort });
  } catch (error) {
    console.log(error);
    Sentry.captureMessage(error, "error");
  }
}

function* fetchMoreOfConvsList({ payload }) {
  const { skip, setLoading, convType } = payload;

  try {
    yield call(fetchConversationsStart, {
      socket,
      convType,
      skip,
      replace: false,
    });
  } catch (error) {
    Sentry.captureMessage(error, "error");
  } finally {
    setLoading(false);
  }
}

export function* fetchUserChannelsStart(socket) {
  let userChannels = yield call(handleFetchUserChannels, socket);

  yield put(setUserChannels(userChannels));
  // now that userChannels is set get users badge
  yield put(setOnlineUsersBadgeStart());
}

export function* fetchContainerInfoStart(socket) {
  const { locale } = yield select(getConversationsInfo);
  let res = yield call(handleFetchContainerInfo, socket);
  yield put(setContainerInfo(createContainerObject(res.data, locale)));

  // fetch other conversations if access granted to the package
  if (res.success) {
    const hasAccessToOtherConvs = res.data.rayPackages.otherConversations;

    if (hasAccessToOtherConvs)
      yield call(fetchConversationsStart, { socket, convType: "otherConvs" });
  }
}

export function* fetchAgentInfoStart(socket, agentId) {
  let agent = yield call(handleFetchAgentInfo, socket, agentId);
  const normalizedAvatar = getNormalizedUrl(agent.avatar);

  yield put(setAgentInfo({ ...agent, avatar: normalizedAvatar }));

  // conversations transfered to current (owner) operator
  if (agent.transfered.length > 0) {
    for (let transferedConv of agent.transfered) {
      const normalizedAvatar = getNormalizedUrl(transferedConv.avatar);

      yield put(
        setTransferedChat({ ...transferedConv, avatar: normalizedAvatar })
      );
    }
  }
  yield put(loadAgent(false));
}

export function* fetchAgentsStart() {
  const agents = yield call(handleFetchAgents, socket);
  const adaptedAgents = getAdaptedOperators(agents);
  yield put(setAgents(adaptedAgents));
}

export function* fetchPretextsStart(socket, agentId) {
  const pretexts = yield call(
    handleFetchOptions,
    socket,
    `${agentId}_pretexts`
  );
  if (pretexts) {
    yield put(setPretexts(pretexts.meta.qa));
  }
}

export function* fetchOnlineUsersStart({ payload }) {
  const { page, limit } = payload || {};
  yield put(setFetchOnlineUsersLoadingStatus(true));

  const onlineUsers = yield call(handleFetchOnlineUsers, {
    socket,
    page,
    limit,
  });

  if (onlineUsers) {
    yield put(setOnlineUsersData({ list: onlineUsers, page }));
  }
}

/**
 two types of teams are sent:
 1. all teams of all channels that operator is member of it
 2. all teams of all channels regardless of operator being member of it or not

 the first one is used when rendering department selectbox and the second one is used when showing the department details in conversation info box. (bottom-left corner)
 the second one is specifically used when showing department of other agents conversations 
 */
function* fetchTeamsStart(socket) {
  const response = yield call(handleFetchTeamsInfo, socket);

  if (response.message === "success") {
    // unifying all teams of all channels
    const allTeamsArr = response.data?.getTeams.reduce((current, item) => {
      return [...current, ...item.teams];
    }, []);

    const adaptedMyTeams = getAdaptedTeams(response.data?.myTeams);
    const adaptedAllTeams = getAdaptedTeams(allTeamsArr);

    yield put(
      setTeams({
        memberofTeams: adaptedMyTeams,
        allTeams: adaptedAllTeams,
      })
    );
  }
}

function* fetchBlockedUsersInfo(socket) {
  try {
    const response = yield call(handleFetchBlockedUsersInfo, socket);
    const blockedUsersList = response.data;

    if (blockedUsersList) {
      yield put(setBlockedUsersList(blockedUsersList));
    }
  } catch (error) {
    console.log(error);
  }
}

function* refetchConversationsList() {
  const { locale } = yield select(getConversationsInfo);
  yield put(setIsReconnecting(true));
  try {
    let socket = yield call(connect);

    if (socket) {
      yield fork(fetchConversationsStart, { socket, convType: "pending" });
      yield fork(fetchConversationsStart, { socket, convType: "ongoing" });
    }
  } catch (error) {
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }
    handleRequestErrors(error.response, locale);
  } finally {
    yield put(setIsReconnecting(false));
  }
}

export function* connectSocket() {
  const agent_id = localStorage.getItem("raychat_web_app_agentId");
  const { locale } = yield select(getConversationsInfo);
  try {
    let socket = yield call(connect);
    if (socket) {
      yield fork(handleIO, socket);
      yield fork(fetchConversationsStart, { socket, convType: "pending" });
      yield fork(fetchConversationsStart, { socket, convType: "ongoing" });
      yield fork(fetchAgentInfoStart, socket, agent_id);
      yield fork(fetchUserChannelsStart, socket);
      yield fork(fetchContainerInfoStart, socket);
      yield fork(fetchAgentsStart);
      yield fork(fetchPretextsStart, socket, agent_id);
      yield fork(fetchChannelSettingsStart, socket);
      yield fork(fetchUserSettingsStart, agent_id);
      yield fork(fetchOnlineUsersStart, {});
      yield fork(changeAgentOnline, { payload: true });
      yield fork(fetchTeamsStart, socket);
      yield fork(fetchBlockedUsersInfo, socket);
    }
    // while (true) {
    // }
  } catch (error) {
    console.error(error);
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }
    handleRequestErrors(error.response, locale);
  }
}

export function* loginUser({ payload }) {
  const { userCredentials, navigate } = payload;
  const { locale } = yield select(getConversationsInfo);
  yield put(setLoginLoading(true));
  try {
    const returnedData = yield handleLoginUser(userCredentials);
    if (returnedData.user.id && returnedData.token) {
      localStorage.setItem("raychat_web_app_token", returnedData.token);
      localStorage.setItem("raychat_web_app_agentId", returnedData.user.id);

      const fcmTokenSavedInStorage = localStorage.getItem(FCM_TOKEN_KEY);

      // if fcm token has already saved in local storage
      if (fcmTokenSavedInStorage) {
        yield call(
          connectNotification,
          fcmTokenSavedInStorage,
          returnedData.token
        );
      }

      yield put(setIsLoggedInUser(true));
      navigate(routes.home);
      yield put(setLoginLoading(false));
    }
  } catch (error) {
    yield put(setLoginLoading(false));

    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }

    handleRequestErrors(error.response, locale);
  }
}

export function* resetPassword({ payload }) {
  const { data, navigate } = payload;
  const { locale } = yield select(getConversationsInfo);
  const fd = new FormData();
  fd.append("email", data.email);
  yield put(setResetPassLoading(true));
  try {
    yield handleResetPassword(fd);
    toast.success(getNotifMsg("RECOVERY_EMAIL_SENT", locale));
    navigate("/login");
  } catch (error) {
    // no connection
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }

    // email not found
    if (error?.response?.status === 403) {
      toast.error(getNotifMsg("EMAIL_NOT_FOUND", locale));
      return;
    }

    handleRequestErrors(error.response, locale);
  } finally {
    yield put(setResetPassLoading(false));
  }
}

function* onFetchMoreOfConvsList() {
  yield takeLatest(chatsTypes.FETCH_MORE_OF_CONVS_LIST, fetchMoreOfConvsList);
}

export function* onSortOngoingConversationsStart() {
  yield takeLatest(chatsTypes.SORT_ONGOING_CONVS_START, sortOngoingConvsStart);
}

export function* onLoginUserStart() {
  yield takeLatest(chatsTypes.LOGIN_USER_START, loginUser);
}

export function* onResetPasswordStart() {
  yield takeLatest(chatsTypes.RESET_PASSWORD_START, resetPassword);
}

export function* onConnectChatsSocketStart() {
  yield takeLatest(chatsTypes.CONNECT_CHATS_SOCKET, connectSocket);
}

export function* onRefetchConversationsLists() {
  yield takeLatest(
    chatsTypes.REFETCH_CONVERSATIONS_LISTS_START,
    refetchConversationsList
  );
}

export default function* chatsSagas() {
  yield all([
    call(onConnectChatsSocketStart),
    call(onLoginUserStart),
    call(onResetPasswordStart),
    call(onSortOngoingConversationsStart),
    call(onFetchMoreOfConvsList),
    call(onFetchUserRoadmapStart),
    call(onRefetchConversationsLists),
  ]);
}
